module.exports = __webpack_public_path__ + "img/download_hint.38439fc0.png";